<template>
    <div class="eleanls">
        <div class="actions">
            <div class="box">
                <div class="actions-func">
                    <Select class="margin-r10 shadow112006" v-model="conditions.ws_id" style="width:150px">
                        <Option v-for="item in workshops" :value="item.ws_id" :key="item.ws_id">{{ item.name }}</Option>
                    </Select>
                    <Select class="margin-r10 shadow112006" v-model="conditions.date" style="width:150px">
                        <Option v-for="item in allMonth" :value="item.date" :key="`date${item.date}`">{{ item.lavel }}</Option>
                    </Select>
                    <RadioGroup class="margin-r10" v-model="conditions.year" type="button" @on-change="changeYear">
                        <Radio v-for="item in allYear" :key="item" :label="item">{{item}}</Radio>
                    </RadioGroup>
                    <Button type="info" class="shadow112006" icon="md-search" @click="searchSubmit">{{$t('search')}}</Button>
                </div>
            </div>
        </div>
        <Card shadow class="card-main" style="box-shadow:0 2px 3px rgba(0,0,0,0.11);">
            <div slot="title">{{cardTitle.name}}</div>
            <div class="card-body">
                <img src="./../../images/temporary/hotrunner.jpg" style="width: 100px;height:100px;">
                <div class="total-finish">
                    <p>{{$t('a_allProductNm')}}</p>
                    <p>
                        <span class="total-data">{{totalPowers.total}}</span>
                        <!-- <span>kwh</span> -->
                    </p>
                </div>
                <div class="chart">
                    <div ref="TotalPowerContainer" style="width: 1000px;height: 100%"></div>
                </div>
            </div>
        </Card>
        <Card shadow class="card-subs" style="box-shadow:0 2px 6px rgba(0,0,0,0.25);">
            <Table :columns="tablecolumns" :data="finishData" border height="664" :loading="tableLoading"></Table>
        </Card>
        <EleFooter></EleFooter>
    </div>
</template>
<script>
import EleFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import echarts from 'echarts';
import Moment from 'moment';

export default {
    components: {
        EleFooter
    },
    props: {
        workshops: Array,
        year: Number
    },
    data() {
        var style = {
            backgroundColor: '#f7f7f7',
            height: '30px',
            lineHeight: '30px'
        };
        var allYear = [];
        allYear.push(this.year - 1);
        allYear.push(this.year);
        var AllMonthData = [
            {
                date: 1,
                lavel: this.$t('a_january')
            },
            {
                date: 2,
                lavel: this.$t('a_february')
            },
            {
                date: 3,
                lavel: this.$t('a_march')
            },
            {
                date: 4,
                lavel: this.$t('a_april')
            },
            {
                date: 5,
                lavel: this.$t('a_may')
            },
            {
                date: 6,
                lavel: this.$t('a_june')
            },
            {
                date: 7,
                lavel: this.$t('a_july')
            },
            {
                date: 8,
                lavel: this.$t('a_august')
            },
            {
                date: 9,
                lavel: this.$t('a_september')
            },
            {
                date: 10,
                lavel: this.$t('a_october')
            },
            {
                date: 11,
                lavel: this.$t('a_november')
            },
            {
                date: 12,
                lavel: this.$t('a_december')
            }
        ];
        var allDays = [];
        for (let i = 0; i < 31; i++) {
            allDays.push({
                title: (i + 1).toString(),
                align: 'center',
                minWidth: 25,
                render: (h, params) => {
                    var finish = params.row.finish31[i].finish;
                    return h('div', [
                        h(
                            'div',
                            {
                                class: 'tb-chart'
                            },
                            [
                                h('div', {
                                    style: { height: `${finish}%` },
                                    class: 'columnar'
                                }),
                                h('div', {
                                    class: 'border'
                                })
                            ]
                        ),
                        h(
                            'p',
                            {
                                style
                            },
                            finish
                        )
                    ]);
                }
            });
        }

        var _FinishMax = 100;
        var tablecolumns = [
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('deviceName'));
                },
                key: 'name',
                align: 'center',
                width: 200,
                fixed: 'left'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_standend'));
                },
                align: 'center',
                fixed: 'left',
                width: 120,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'div',
                            {
                                class: 'tb-standard'
                            },
                            `${_FinishMax / 2}`
                        ),
                        h(
                            'p',
                            {
                                style
                            },
                            this.$t('finishNum')
                        )
                    ]);
                }
            },
            {
                title: '--',
                align: 'center',
                children: allDays
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_averageValue'));
                },
                key: 'average',
                align: 'center',
                width: 150,
                fixed: 'right',
                render: (h, params) => {
                    return h('div', [
                        h(
                            'span',
                            {
                                style: {
                                    fontSize: '22px',
                                    color: '#E51C22'
                                }
                            },
                            params.row.average
                        )
                        // h(
                        //     'span',
                        //     {
                        //         style: {
                        //             paddingLeft: '3px',
                        //             fontSize: '16px'
                        //         }
                        //     },
                        //     'kwh'
                        // )
                    ]);
                }
            }
        ];
        return {
            Cancel: null, //添加取消请求函数
            _FinishMax,
            AllMonthData, //保存下所有的月份
            allMonth: [],
            allYear,
            tablecolumns,
            tableLoading: true,
            conditions: {
                cid: this.$store.state.user.cid,
                ws_id: 0, //当前选中的车间id
                year: 1970,
                date: 1, //日期
                start: '2019-01-01',
                end: '2019-01-31'
            },
            finishData: [], //所有电量数据
            totalPowers: {
                //所有的用电量
                total: 0,
                finishs: []
            },
            myBarChart: {}
        };
    },
    created() {
        this.$store.commit('upNavbar', 6);
        //找出当前月
        var currentMonth = new Date().getMonth(); //0-11
        var months = this.AllMonthData.slice(0, currentMonth + 1);
        this.allMonth = months;
        this.conditions.year = this.year;
        this.conditions.date = currentMonth + 1;
        this.tablecolumns[2].title = `${this.conditions.year}-${this.conditions.date}`;
        this.conditions.start = Moment([this.year, 0, 1])
            .month(currentMonth)
            .format('YYYY-MM-DD');
        this.conditions.end = Moment([this.year, 0, 31])
            .month(currentMonth)
            .format('YYYY-MM-DD');
    },
    mounted() {
        this.getPowers();
        let dom = this.$refs.TotalPowerContainer;
        this.myBarChart = echarts.init(dom);
    },
    methods: {
        //百度图标的option
        opt(data) {
            var options = {
                color: ['#1098d2'],
                grid: {
                    top: 5,
                    bottom: 19
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: this.$t('finishNum'),
                        type: 'bar',
                        data: data
                    }
                ]
            };
            return options;
        },
        //修改了年份
        changeYear(value) {
            if (value == this.year) {
                var currentMonth = new Date().getMonth(); //0-11
                var months = this.AllMonthData.slice(0, currentMonth + 1);
                this.allMonth = months;
                this.conditions.date = currentMonth + 1;
            } else {
                this.allMonth = this.AllMonthData;
                this.conditions.date = 1;
            }
        },
        //获得用电量数据
        getPowers() {
            if (this.Cancel != null) this.Cancel(); //进来先删除上一次请求
            let CancelToken = Axios.CancelToken;
            let options = Object.assign({}, this.conditions);
            options.ws_id = options.ws_id ? options.ws_id : '';
            Axios.get(AxiosUrl.analysis.groupyield, {
                params: options,
                cancelToken: new CancelToken(c => {
                    this.Cancel = c;
                })
            })
                .then(res => {
                    if (res.data.code == 200) {
                        this.finishData = [];
                        var data = res.data.data;
                        var totalFinish = 0;
                        data.forEach(item => {
                            var average = 0; //每个机器的平均数
                            var finish31 = [];
                            for (let i = 1; i <= 31; i++) {
                                finish31.push(new Object({ finish: 0, date: i }));
                            }
                            item.yield.forEach(it => {
                                average += it.finish;
                                finish31[Moment(it.time).date() - 1].finish = it.finish;
                            });
                            totalFinish += average;
                            item.average = 0.0;
                            if (item.yield.length != 0) {
                                item.average = (average / item.yield.length).toFixed(1);
                            }
                            item.finish31 = finish31;
                        });
                        //整理每天所有的数据
                        var finishDay = 0;
                        var finishDayArr = [];
                        for (let i = 1; i <= 31; i++) {
                            data.forEach(item => {
                                finishDay += item.finish31[i - 1].finish;
                            });
                            finishDayArr.push(finishDay);
                            finishDay = 0;
                        }
                        this.totalPowers.total = totalFinish;
                        this.totalPowers.finishs = finishDayArr;
                        this.myBarChart.setOption(this.opt(finishDayArr));
                        this.finishData = data;
                        this.tableLoading = false;
                    } else {
                        console.log(res.data.msg);
                    }
                })
                .catch(err => {});
        },
        //点击查询
        searchSubmit() {
            this.conditions.start = Moment([this.conditions.year, 0, 1])
                .month(this.conditions.date - 1)
                .format('YYYY-MM-DD');
            this.conditions.end = Moment([this.conditions.year, 0, 31])
                .month(this.conditions.date - 1)
                .format('YYYY-MM-DD');
            this.tablecolumns[2].title = `${this.conditions.year}-${this.conditions.date}`;
            this.tableLoading = true;
            this.getPowers();
        }
    },
    computed: {
        cardTitle() {
            var shops = this.workshops.filter(item => {
                return item.ws_id == this.conditions.ws_id;
            });
            return shops[0];
        }
    }
};
</script>
<style lang="less">
.eleanls {
    .card-main {
        border-radius: 4px 4px 0 0;
        z-index: 2;
        .card-body {
            padding: 0 10px;
            display: flex;
            .total-finish {
                font-size: 16px;
                padding: 20px 0 0 60px;
                .total-data {
                    font-size: 30px;
                    color: #e51c22;
                }
            }
            .chart {
                margin-left: 70px;
            }
        }
    }
    .card-subs {
        border-radius: 0 0 4px 4px;
        background-color: #f2f2f2;
        .tb-standard {
            height: 104px;
            width: 100%;
            line-height: 104px;
            text-align: right;
            position: relative;
            padding: 0 15px;
            border-bottom: 1px solid #e8eaec;
        }
        .tb-standard:after {
            content: '';
            display: inline-block;
            position: absolute;
            right: 0px;
            top: 47px;
            border-width: 5px 0 5px 5px;
            border-style: solid;
            border-color: transparent transparent transparent #4b4f51;
        }
        .tb-chart {
            height: 104px;
            width: 100%;
            border-bottom: 1px solid #e8eaec;
            padding: 2px 0;
            position: relative;
            .columnar {
                position: absolute;
                bottom: 2px;
                left: 10px;
                right: 10px;
                background-color: #1098d2;
            }
            .border {
                position: absolute;
                bottom: 0;
                height: 50%;
                width: 100%;
                border-top: 1px dashed #bbb;
            }
        }
        .ivu-table-cell {
            padding: 0;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/analysis/finishanls.vue